import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PlanType from './PlanType';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

// const subscriptionPlanTypes = [
//   'tier_1m',
//   'tier_2m',
//   'tier_3m',
//   'tier_1a',
//   'tier_2a',
//   'tier_3a',
// ]

class SelectPlan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      planType: 'monthly',
    };

    this.onClickToggle = this.onClickToggle.bind(this);
  }

  getPlanTitle = (type) => {
    let planTitle = '$0';

    switch (type) {
      case 'tier_1m':
        planTitle = '$195/month';
        break;

      case 'tier_2m':
        planTitle = '$500/month';
        break;

      case 'tier_3m':
        planTitle = 'Contact us';
        break;

      case 'tier_1a':
        planTitle = '$2140';
        break;

      case 'tier_2a':
        planTitle = '$5000';
        break;

      case 'tier_3a':
        planTitle = 'Contact us';
        break;

        
      default:
        break;
    }

    return planTitle;
  };

  getButtonTitle = (type) => {
    const { subscriptionPlan } = this.props;

    let title = 'Select Plan';

    if (subscriptionPlan === type) {
      title = 'Current Plan';
    }

    return title;
  };

  onHandlePlan = (type) => {
    const { subscriptionPlan } = this.props;

    if (subscriptionPlan === type) return;

    this.props.handlePlan(type);
  };

  onClickToggle() {
    const toggle = document.querySelector('#toggle-plan-type');

    if (toggle) {
      this.setState({
        planType: toggle.checked ? 'annual' : 'monthly',
      });
    }
  }

  render() {
    const {
      show,
      hidePlanModal,
      exitedPlanModal,
    } = this.props;

    return (
      <Modal
        dialogClassName="user-plan-modal select-plan-modal"
        show={show}
        onHide={hidePlanModal}
        onExited={exitedPlanModal}
        renderBackdrop={() => <div style={backdropStyle} />}
      >
        <Modal.Header closeButton>
          <div className="modal-title">Select a Plan</div>
        </Modal.Header>
        <Modal.Body>
          <div className='plan-toggle'>
            <label className='switch' onClick={this.onClickToggle}>
              <input id="toggle-plan-type" type='checkbox' />
              <span className='slider w-full'>
                <span className='w-full'>Monthly</span>
                <span className='w-full'>Annual</span>
              </span>
            </label>
          </div>
          <div className="plan-list">
            <PlanType
              type={this.state.planType === 'monthly' ? 'tier_1m' : 'tier_1a'}
              planName='Starter'
              planTitle={this.getPlanTitle(
                this.state.planType === 'monthly' ? 'tier_1m' : 'tier_1a'
              )}
              buttonTitle={this.getButtonTitle(
                this.state.planType === 'monthly' ? 'tier_1m' : 'tier_1a'
              )}
              handlePlan={(type) => this.onHandlePlan(type)}
              blurb='Protect 1 Publication'
              description='Includes federal filing fees'
            />
            <PlanType
              type={this.state.planType === 'monthly' ? 'tier_2m' : 'tier_2a'}
              planName='Growth'
              planTitle={this.getPlanTitle(
                this.state.planType === 'monthly' ? 'tier_2m' : 'tier_2a'
              )}
              buttonTitle={this.getButtonTitle(
                this.state.planType === 'monthly' ? 'tier_2m' : 'tier_2a'
              )}
              handlePlan={(type) => this.onHandlePlan(type)}
              blurb='Protect Up to 10 Publications'
              description={
                `Additional federal filing fees of $${
                  this.state.planType === 'monthly' ? '95/month' : '1.140/URL'
                } will apply for each active publication.`
              }
            />
            <PlanType
              type={this.state.planType === 'monthly' ? 'tier_3m' : 'tier_3a'}
              planName='Enterprise'
              planTitle={this.getPlanTitle(
                this.state.planType === 'monthly' ? 'tier_3m' : 'tier_3a'
              )}
              buttonTitle={this.getButtonTitle(
                this.state.planType === 'monthly' ? 'tier_3m' : 'tier_3a'
              )}
              handlePlan={(type) => this.onHandlePlan(type)}
              blurb='Protect 10+ Publications'
              description={
                `Additional federal filing fees of $${
                  this.state.planType === 'monthly' ? '95/month' : '1.140/URL'
                } will apply for each active publication.`
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons">
            <button className="nevermind" onClick={hidePlanModal}>
              Nevermind, I'll upgrade later.
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SelectPlan;



// WEBPACK FOOTER //
// src/components/UserPlan/SelectPlan.jsx